import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartSheet from "@/components/CartSheet";
import Home from "@/pages/Home";
import ProductPage from "@/pages/ProductPage";
import Checkout from "@/pages/Checkout";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import TrackOrder from "@/pages/TrackOrder";
import Delivery from "@/pages/Delivery";
import Christmas from "@/pages/Christmas";
import Hampers from "@/pages/Hampers";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import Contact from "@/pages/Contact";
import Unsubscribe from "@/pages/Unsubscribe";
import GiftCards from "@/pages/GiftCards";
import BasketRestore from "@/pages/BasketRestore";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <Header />
            <CartSheet />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/product/:id" element={<ProductPage />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/track" element={<TrackOrder />} />
                <Route path="/delivery" element={<Delivery />} />
                <Route path="/christmas" element={<Christmas />} />
                <Route path="/gifts" element={<Christmas />} />
                <Route path="/hampers" element={<Hampers />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/gift-cards" element={<GiftCards />} />
                <Route path="/basket/:id" element={<BasketRestore />} />
                <Route path="/unsubscribe" element={<Unsubscribe />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
            </main>
            <Footer />
            <Toaster position="top-center" richColors />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
